import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';
import { Provider } from 'react-redux';

import { loadContainers } from '@eika-infrastruktur/render';

import { fetchTestUserToggle, loadConfig } from './actions';
import CustomAppTypes from './config/customAppTypes';
import resolveLocalConfigData from './config/localFallbackData';
import { configureStore } from './configure-store';
import App from './containers/App';
import { initialState } from './reducers/context';
import Routes from './routes';

import './styles/main.scss';

type ContextReducer = import('./reducers/context').ContextReducer;

const store = configureStore();
const defaultNamespace = 'kredittkort.soknad';
const { defaultAppType } = initialState;
const nameSpaceStart = `${defaultNamespace}.`;

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            refetchIntervalInBackground: false,
            staleTime: Infinity,
            retry: false,
        },
    },
});

const renderApp = (namespace: string) => {
    loadContainers(namespace, ({ config }: ContextReducer | any) => {
        const namespaceContainsAppType = namespace.length > defaultNamespace.length;
        const appType = namespaceContainsAppType ? namespace.substring(nameSpaceStart.length) : defaultAppType;
        const localConfigData = resolveLocalConfigData(appType, defaultAppType);
        // @ts-ignore
        store.dispatch(loadConfig(config, localConfigData, appType));
        store.dispatch(fetchTestUserToggle());

        return (
            <div
                className="sgw-content kredittbank-kredittkort-soknad-web"
                style={{ marginTop: '75px', marginBottom: '75px' }}
            >
                <Provider store={store}>
                    <QueryClientProvider client={queryClient}>
                        <App>
                            <Routes />
                        </App>
                        <ReactQueryDevtools initialIsOpen={false} />
                    </QueryClientProvider>
                </Provider>
            </div>
        );
    });
};

const renderApps = () => {
    renderApp(defaultNamespace);
    CustomAppTypes.all().forEach((customAppType) => renderApp(`${defaultNamespace}.${customAppType}`));
};

renderApps();
